module.exports = __webpack_public_path__ + "static/media/insumma.02fcc421.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/insumma.webp
// module id = 533
// module chunks = 0